import React from "react";

import "./Loader.scoped.scss";

const Loader = () => {
	return (
		<div className="l-container">
			<div className="plane-loader">
				<i className="globe first fas fa-globe-americas" />
				<i className="globe second fas fa-globe-africa" />
				<i className="globe third fas fa-globe-europe" />
				<i className="globe fourth fas fa-globe-asia" />
				<i className="globe fifth fas fa-globe-americas" />
				{/* <i class="arrow fas fa-share" /> */}
				<div className="plane-container">
					<i className="shadow fas fa-plane" />
					<i className="plane fas fa-plane" />
				</div>
			</div>
		</div>
	);
};

export default Loader;
